export default __webpack_public_path__ + "static/media/thumpsup.cbad82e6.png";